import styles from "./successDelete.module.css";
import { Image } from "react-bootstrap";
import loaderImg from "../../../assests/images/delete_success.svg";
export const SuccessDelete = () => {
  return (
    <div className={styles.deleteMain}>
      <Image className={styles.loaderImg} fluid src={loaderImg} />
    </div>
  );
};
